import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzImageService } from 'ng-zorro-antd/image';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { CustomValidatorService } from '../../../service/custom-validator.service';
import { EquipmentService } from '../../../service/equipment.service';
import { PatrolAreaService } from '../../../service/patrol-area.service';
import { JobLocationState } from '../../../store/jobLocation/job-location-state';
import { JobTypeState } from '../../../store/jobType/job-type-state';
import { ApplyService } from '../../../service/apply.service';
import { AuthState } from '../../../store/authInfo/auth-state';
import { PhotoSwipeComponent } from '../../../common/photo-swipe/photo-swipe.component';

@Component({
  selector: 'app-job-repair-apply',
  templateUrl: './job-repair-apply.component.html',
  styleUrls: ['./job-repair-apply.component.less']
})
export class JobRepairApplyComponent implements OnInit {

  @Output() nzSuccessApply = new EventEmitter<any>();
  @ViewChild(PhotoSwipeComponent)
  photoSwipe: PhotoSwipeComponent;
  @ViewChild('typeTreeSelect') typeTreeSelect: NzTreeSelectComponent;
  @Input() pageFlag: any;
  @Input() equipmentNo: any;
  @Input() equipmentName: any;
  @Input() alarmMsg: any;
  attachments: { type: string ; url: string; isNew: 0 } [] = [] ;
  validateForm: FormGroup = null;
  authState = null;
  jobTypes = [];
  jobLocations = [];
  equipments = [];
  beforeValue = '';
  nzFilterOption = () => true;
  // tslint:disable-next-line:member-ordering
  typeMap = new Map<number, any>();

  constructor(
    private fb: FormBuilder,
    private store: Store,
    private equipmentService: EquipmentService,
    private customValidatorService: CustomValidatorService,
    private message: NzMessageService,
    private applyService: ApplyService,
    private nzImageService: NzImageService,
    private areaService: PatrolAreaService
  ) { }

  async ngOnInit(): Promise<void> {
    this.authState = this.store.selectSnapshot<any[]>(AuthState);
    this.jobTypes = this.initTypeTree(this.store.selectSnapshot<any[]>(JobTypeState));
    this.jobLocations = this.initLocations(this.store.selectSnapshot<any[]>(JobLocationState));
    this.validateForm = this.fb.group({
      epNo: [null], // 设备编号
      epName: [{value: null, disabled: true}], // 设备名称
      location: [null, [Validators.required]], // 所在位置
      jtNo: [null, [Validators.required]], // 类型
      callerName: [this.authState.userInfo.userName, [Validators.required]], // 报修人姓名
      // tslint:disable-next-line:max-line-length
      callerPhone: [this.authState.userInfo.phonenumber, [Validators.required, this.customValidatorService.tellPhoneNumberValidator]], // 报修人电话
      mark: [null, [Validators.required]], // 描述信息
      deviceType: ['other']
    });
    if (this.pageFlag === 'alarm') {
      this.equipments = [];
      this.equipments.push({
        value: this.equipmentNo,
        text: this.equipmentNo
      });
      this.validateForm = this.fb.group({
        epNo: [this.equipmentNo], // 设备编号
        epName: [{value: this.equipmentName, disabled: true}], // 设备名称
        location: [null, [Validators.required]], // 所在位置
        jtNo: [null, [Validators.required]], // 类型
        callerName: [this.authState.userInfo.userName, [Validators.required]], // 报修人姓名
        // tslint:disable-next-line:max-line-length
        callerPhone: [this.authState.userInfo.phonenumber, [Validators.required, this.customValidatorService.tellPhoneNumberValidator]], // 报修人电话
        mark: [this.alarmMsg, [Validators.required]], // 描述信息
        deviceType: ['equipment']
      });
    }
  }
  initTypeTree(types: any[]) {
    const jobTypes = [];
    const typeMap = new Map<number, any>();
    for (const type of types) {
      const node = {
        title: type.skillName,
        value: type.skillId,
        key: type.skillId,
        isLeaf: true
      };
      if (type.parentId === 0) {
        jobTypes.push(node);
      } else {
        const parent = this.typeMap.get(type.parentId);
        if (parent != null) {
          if (parent.children == null) {
            parent.children = [];
            parent.isLeaf = false;
          }
          parent.children.push(node);
        }
      }
      this.typeMap.set(type.skillId, node);
    }
    return jobTypes;
  }
  initLocations(locations: any[]){
    const locationList = [];
    const locationMap = new Map<any, any>();
    for (const location of locations) {
      const node = {
        title: location.locationName,
        value: location.locationId,
        key: location.locationName,
        isLeaf: true
      };
      if (locationMap.has(location.parentId)) {
        const parent = locationMap.get(location.parentId);
        if (parent.children == null) {
          parent.children = [];
          parent.isLeaf = false;
        }
        parent.children.push(node);
      } else {
        locationList.push(node);
      }
      locationMap.set(location.locationId, node);
    }
    return locationList;
  }
  treeSelectChanged(key) {
    if (!this.isEmpty(key)) {
      const node = this.typeTreeSelect.getTreeNodeByKey(key);
      if (node != null) {
        if (node.isLeaf) {
          this.beforeValue = key;
        } else {
          this.validateForm.get('jtNo').setValue(this.beforeValue);
        }
      }
    }
  }
  public onModelChangeType($event){
    this.validateForm.get('epNo').setValue(null);
    this.validateForm.get('epName').setValue(null);
  }
  public nzmodelChange($event){
    if ( !this.isEmpty($event) && $event.indexOf(':') > 0){
      const ls = $event.split(':');
      this.equipments = [];
      this.equipments.push({
        value: ls[0],
        text: ls[0]
      });
      this.validateForm.get('epNo').setValue(ls[0]);
      this.validateForm.get('epName').setValue(ls[1]);
      this.validateForm.get('location').setValue(ls[2]);
    }
  }
  search(value: string): void {
    if (!this.isEmpty(value)){
      if (this.validateForm.get('deviceType').value === 'area'){
        this.areaService.getAreasByFilterString(value)
        .subscribe(data => {
          const listOfOption: Array<{ value: string, text: string }> = [];
          data.forEach(item => {
            listOfOption.push({
              value: item.areaNo + ':' + item.areaName + ':' + item.location,
              text: item.areaNo + ':' + item.areaName
            });
          });
          this.equipments = [];
          this.equipments  = listOfOption;
        });
      }
      if (this.validateForm.get('deviceType').value === 'equipment'){
        this.equipmentService.
        getEquipmentsByFilterString(value)
          .subscribe(data => {
            const listOfOption: Array<{ value: string, text: string }> = [];
            data.forEach(item => {
              listOfOption.push({
                value: item.epNo + ':' + item.epName + ':' + (this.isEmpty(item.storeLocation) ? '' : item.storeLocation),
                text: item.epNo + ':' + item.epName
              });
            });
            this.equipments = [];
            this.equipments  = listOfOption;
          });
      }

    }
  }
  async submitForm(){
    if (this.validateForm.value.deviceType !== 'other'){
      this.validateForm.get('epNo').setValidators(Validators.required);
    }else{
      this.validateForm.get('epNo').clearValidators();
    }
    const validated = this.validateFormData();
    if (validated) {
      const result: any = await this.applyService.addJob({
        jtNo: this.validateForm.value.jtNo,
        callerName: this.validateForm.value.callerName,
        callerPhone: this.validateForm.value.callerPhone,
        location: this.validateForm.value.location,
        isEquipment: this.validateForm.value.deviceType !== 'other' ? '1' : '0',
        epNo: this.validateForm.value.epNo,
        mark: this.validateForm.value.mark,
        callerId: this.authState.userInfo.staffNo,
        createBy: this.authState.userInfo.userId,
        updateBy: this.authState.userInfo.userId,
        attachments: this.attachments,
        source: '0' // 0表示该工单为报修工单
      });
      if (result != null && result.code === 200) {
        this.message.success('报修成功');
        this.nzSuccessApply.emit();
      }else{
        this.message.error(result.msg);
        return;
      }
    } else {
      this.message.warning('工单数据未验证通过');
    }
  }
  public validateFormData() {
    // tslint:disable-next-line:forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    return this.validateForm.valid;
  }
  preview(event) {
    const options = {
      index: event.index,
    };
    const files = [];
    event.files.forEach(file => {
      const image = new Image();
      image.src = file.url;
      files.push({
        src: file.url,
        width: image.width,
        height: image.height,
        alt: ''
      });
    });
    this.nzImageService.preview(files, { nzZoom: 1.5, nzRotate: 0 });
  }
  public isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
